<template>
  <div class="asc-checkbox-icon">
    <v-icon
      v-show="checked"
      size="14"
      :color="getIconColor"
      :class="['icon-accent', disabled ? 'icon-accent-disabled' : null]"
    >
      mdi-check-bold
    </v-icon>
    <div
      v-show="!checked"
      :class="[
        'icon-blank-outline',
        disabled ? 'icon-blank-outline-disabled' : null,
      ]"
    ></div>
  </div>
</template>

<script>
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscCheckboxIcon',

  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getIconColor() {
      return this.disabled ? variables.gray600 : variables.primaryblack
    },
  },
}
</script>

<style lang="scss">
.asc-checkbox-icon {
  margin-left: 1px;

  & .v-icon {
    border: 1px solid $gray-700;
    background-color: $gray-700;
  }

  & .icon-accent {
    border: 1px solid $accent-400;
    background-color: $accent-400;
    margin-top: 2px;
  }

  & .icon-accent-disabled {
    border: 1px solid $gray-600;
    background-color: $gray-200 !important;
  }

  & .icon-blank-outline {
    border: 1px solid $gray-400;
    height: 15px;
    width: 16px;
    margin-top: 3px;
  }

  & .icon-blank-outline-disabled {
    border: 1px solid $gray-600;
    background-color: $gray-200 !important;
  }
}
</style>
